<app-baseend-page class="loader-container" image="./assets/img/loader.webm"
    title="Estamos consultando tus datos..." [buttons]="[]" [isLoaderComponent]="true">
</app-baseend-page>